<div class="flex flex-col gap-4">
  <!-- Add owner -->
  <mat-form-field class="w-full md:w-1/2">
    <mat-label>{{ 'waters.owners.add-label' | translate }}</mat-label>
    <input
      matInput
      [formControl]="searchControl"
      [matAutocomplete]="auto"
      placeholder="{{ 'waters.owners.add-placeholder' | translate }}" />
    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayOwner" (optionSelected)="onOwnerSelected($event)">
      @for (c of ownerOptions(); track c.id) {
        <mat-option [value]="c">
          {{ c.firstName }} {{ c.lastName }}
          @if (c.email) {
            <span class="text-gray-400 text-xs"> — {{ c.email }}</span>
          }
        </mat-option>
      }
    </mat-autocomplete>
    @if (linking()) {
      <mat-spinner matSuffix diameter="18" />
    }
    <mat-hint>{{ 'waters.owners.add-hint' | translate }}</mat-hint>
  </mat-form-field>

  @if (isLoading()) {
    <div class="flex justify-center items-center h-24">
      <mat-spinner diameter="32" />
    </div>
  } @else if (owners().length === 0) {
    <p class="text-center text-gray-500 py-6">{{ 'waters.owners.no-owners' | translate }}</p>
  } @else {
    <mat-table [dataSource]="owners()">
      <!-- Name column (first + last, with a star on the primary owner) -->
      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef>{{ 'waters.owners.column.name' | translate }}</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="flex items-center gap-1">
            @if (row.isPrimary) {
              <mat-icon
                class="!text-amber-500 !w-5 !h-5 !text-xl !leading-5"
                [matTooltip]="'waters.owners.primary' | translate"
                >star</mat-icon
              >
            }
            {{ row.firstName }} {{ row.lastName }}
          </span>
        </mat-cell>
      </ng-container>

      <!-- Email column -->
      <ng-container matColumnDef="email">
        <mat-header-cell *matHeaderCellDef>{{ 'waters.owners.column.email' | translate }}</mat-header-cell>
        <mat-cell *matCellDef="let row">{{ row.email ?? '—' }}</mat-cell>
      </ng-container>

      <!-- Actions column -->
      <ng-container matColumnDef="actions">
        <mat-header-cell *matHeaderCellDef>{{ 'waters.owners.column.actions' | translate }}</mat-header-cell>
        <mat-cell *matCellDef="let row">
          @if (!row.isPrimary) {
            <button
              mat-icon-button
              [matTooltip]="'waters.owners.set-primary' | translate"
              [disabled]="busyId() === row.id"
              (click)="setPrimary(row.id)">
              <mat-icon>star_border</mat-icon>
            </button>
          }
          <button mat-icon-button [matTooltip]="'waters.owners.edit' | translate" (click)="editOwner(row.id)">
            <mat-icon>edit</mat-icon>
          </button>
          <button
            mat-icon-button
            color="warn"
            [matTooltip]="'waters.owners.unlink' | translate"
            [disabled]="busyId() === row.id"
            (click)="unlinkOwner(row.id)">
            @if (busyId() === row.id) {
              <mat-spinner diameter="18" />
            } @else {
              <mat-icon>link_off</mat-icon>
            }
          </button>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns" />
      <mat-row *matRowDef="let row; columns: displayedColumns" />
    </mat-table>
  }
</div>
